export default __webpack_public_path__ + "static/media/platforma.75c7561d.svg";